function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15z",
  fill: "#C8232C"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.572 17.189l-.07.26c-.18.662-.36 1.326-.542 1.989-.113.41-.292.797-.5 1.171a10.195 10.195 0 0 1-1.099 1.586.176.176 0 0 1-.074.054.11.11 0 0 1-.15-.09 10.803 10.803 0 0 1-.125-1.186 9.09 9.09 0 0 1 .001-.93c.017-.3.048-.597.114-.89.057-.254.123-.506.186-.758l.765-3.053c.07-.282.14-.564.212-.845a.155.155 0 0 0-.008-.11 2.9 2.9 0 0 1-.226-.797 3.075 3.075 0 0 1-.025-.703c.039-.469.176-.907.472-1.292.188-.244.423-.435.723-.548.267-.1.543-.12.822-.059.387.085.64.317.78.662.075.189.102.385.1.585-.004.239-.05.47-.107.702-.095.389-.224.769-.349 1.15-.117.358-.234.716-.325 1.08-.085.339-.053.664.136.966.204.326.51.526.9.608.443.095.865.023 1.265-.174.308-.152.56-.367.779-.618.274-.315.477-.668.639-1.043a5.88 5.88 0 0 0 .388-1.344 7.35 7.35 0 0 0 .101-1.17 3.268 3.268 0 0 0-.276-1.402c-.323-.713-.872-1.216-1.621-1.527a4.192 4.192 0 0 0-1.06-.276 5.482 5.482 0 0 0-.943-.042c-.845.033-1.633.244-2.336.696a3.854 3.854 0 0 0-1.668 2.223c-.123.421-.17.851-.143 1.287.032.54.21 1.026.59 1.44.03.033.057.069.083.104a.297.297 0 0 1 .053.26c-.041.165-.086.33-.13.495-.022.085-.044.17-.069.253a.508.508 0 0 1-.037.096.288.288 0 0 1-.326.147.678.678 0 0 1-.114-.035 2.544 2.544 0 0 1-1.211-1.003 3.368 3.368 0 0 1-.45-1.072 4.589 4.589 0 0 1-.112-1.427 4.495 4.495 0 0 1 .436-1.603c.542-1.133 1.406-1.983 2.568-2.566a6.674 6.674 0 0 1 1.808-.593 8.294 8.294 0 0 1 1.576-.132c.935.009 1.83.185 2.672.579.976.458 1.744 1.127 2.276 2.028.284.481.467.995.553 1.54.054.34.054.683.04 1.025a7.032 7.032 0 0 1-.08.797c-.144.93-.449 1.807-1 2.598a4.551 4.551 0 0 1-1.41 1.327 4.295 4.295 0 0 1-1.613.567 4.086 4.086 0 0 1-.823.042c-.62-.037-1.175-.232-1.651-.614a1.5 1.5 0 0 1-.34-.38l-.025-.035z",
  fill: "#fff"
});

var SvgPinterestRedesign = function SvgPinterestRedesign(props) {
  return React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "e58e27bd024d1539c500349c20fbbe44.svg";
export { SvgPinterestRedesign as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/pinterest-redesign.svg
// module id = null
// module chunks = 